import React, { useEffect, useState } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { AppProvider, useApp } from './context/AppContext';
import { Sidebar } from './components/Navigation/Sidebar';
import { BottomNav } from './components/Navigation/BottomNav';
import { MapScreen } from './pages/MapScreen';
import { RegulationsScreen } from './pages/RegulationsScreen';
import { PermitsScreen } from './pages/PermitsScreen';
import { RecommendationsScreen } from './pages/RecommendationsScreen';
import { motion, AnimatePresence } from 'framer-motion';
type NavItem = 'map' | 'regulations' | 'permits' | 'recommendations';
function AppContent() {
  const [activeTab, setActiveTab] = useState<NavItem>('map');
  const {
    activeLocationId
  } = useApp();
  useEffect(() => {
    if (activeLocationId) {
      setActiveTab('map');
    }
  }, [activeLocationId]);
  const renderContent = () => {
    switch (activeTab) {
      case 'map':
        return <MapScreen data-id="element-0" />;
      case 'regulations':
        return <RegulationsScreen data-id="element-1" />;
      case 'permits':
        return <PermitsScreen data-id="element-2" />;
      case 'recommendations':
        return <RecommendationsScreen data-id="element-3" />;
      default:
        return <MapScreen data-id="element-4" />;
    }
  };
  return <div className="flex h-screen w-full bg-[var(--bg-primary)] overflow-hidden" data-id="element-5">
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} data-id="element-6" />

      <main className="flex-1 h-full relative md:ml-64 overflow-y-auto overflow-x-hidden" data-id="element-7">
        <AnimatePresence mode="wait" data-id="element-8">
          <motion.div key={activeTab} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.15
        }} className="h-full" data-id="element-9">
            {renderContent()}
          </motion.div>
        </AnimatePresence>
      </main>

      <BottomNav activeTab={activeTab} onTabChange={setActiveTab} data-id="element-10" />
    </div>;
}
export function App() {
  return <ThemeProvider data-id="element-11">
      <AppProvider data-id="element-12">
        <AppContent data-id="element-13" />
      </AppProvider>
    </ThemeProvider>;
}